//#region src/utils/error.ts
function coerceToError(error) {
	return error instanceof Error ? error : Error(typeof error === "string" ? error : JSON.stringify(error));
}
function assert(condition, message) {
	if (!condition) throw Error(message || "Assertion failed.");
}
//#endregion
export { assert, coerceToError };
